import { render, staticRenderFns } from "./VerificationFormExternalSignApi.vue?vue&type=template&id=fe857218&"
import script from "./VerificationFormExternalSignApi.vue?vue&type=script&lang=js&"
export * from "./VerificationFormExternalSignApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe857218')) {
      api.createRecord('fe857218', component.options)
    } else {
      api.reload('fe857218', component.options)
    }
    module.hot.accept("./VerificationFormExternalSignApi.vue?vue&type=template&id=fe857218&", function () {
      api.rerender('fe857218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/signApi/components/VerificationFormExternalSignApi.vue"
export default component.exports